import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class'

import * as fieldComponents from '../../components/fields/email-text-v1/email-text-v1-index'

@Injectable({
    providedIn: 'root'
  })
export class EmailTextV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'email-text-v1';
    menuTitle: string = "Email Address";
    deprecated: boolean = false;

    /**
     * 
     * @param field the object data of the field
     * @returns EmailTextV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.EmailTextV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsEmailTextV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsEmailTextV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        return new fields.SettingsEmailTextV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
    }


    getSettingsComponentType(): Type<fieldComponents.SettingsEmailTextV1FieldComponent> {
        return fieldComponents.SettingsEmailTextV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillEmailTextV1FieldComponent> {
        return fieldComponents.FillEmailTextV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewEmailTextV1FieldComponent>{ 
        return fieldComponents.ViewEmailTextV1FieldComponent;
    }


}